import type { SearchParams } from '@app/constants/StoreTypes'

export const MIN_MINUTES_TO_START = 2 * 60
export const START_END_MINUTES_DIFF = 60
export const RATE_RANGE_MIN_RATE = 100
export const RATE_RANGE_MAX_RATE = 1500
export const RATE_RANGE_DELTA = RATE_RANGE_MAX_RATE - RATE_RANGE_MIN_RATE

export const SITTER_SEARCH_ONLINE_QUERY_KEYS: (keyof SearchParams)[] = ['online', 'special_needs', 'kidsout_school', 'perks', 'only_vacant', 'sort']
